'use strict';
// Reservations count only after durable local save. Reconnect/resume never consumes twice.
async function startBotWithEntitlement({enabled,request,requestId,create,persist,isCurrent=()=>true}){
 let reserved=false,saved=false;
 const current=()=>{if(!isCurrent())throw Error('Hesap değişti.');};
 try{
  current();if(enabled){const status=await request('status');current();if(status.enabled&&status.botGateEnabled){if(status.bot?.remaining<=0)return {blocked:true,status};const permit=await request('reserve',{requestId});current();reserved=permit.enabled===true;}}
  const state=create();if(reserved)state.botAdReceipt={requestId};current();await persist(state);saved=true;current();
  if(reserved)void request('commit',{requestId}).catch(()=>{});
  return {state};
 }catch(e){if(enabled&&!saved)void request('cancel',{requestId}).catch(()=>{});if(e.code==='BOT_AD_LIMIT')return {blocked:true};throw e;}
}
module.exports={startBotWithEntitlement};
